import { useState, useEffect, useDebugValue } from 'react';
import { useHubspotContext } from './HubspotProvider.js';

const useHubspotForm = (formProps) => {
    const { loaded, error } = useHubspotContext();
    const [formCreated, setFormCreated] = useState(false);
    useEffect(() => {
        if (loaded && !formCreated) {
            try {
                window.hbspt.forms.create(formProps);
                setFormCreated(true);
            }
            catch (e) {
                console.warn("Failed to create hubspot form:");
                console.error(e);
                setFormCreated(false);
            }
        }
        // Don't include 'formProps' here to avoid rerenders
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loaded, formCreated, setFormCreated]);
    useDebugValue(`Form created: ${formCreated}`);
    return { loaded, formCreated, error };
};

export { useHubspotForm };
